import React__default from 'react';
import { Price } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const SinglePurchasePriceCaption = ({ price  })=>{
    const { currency  } = useIntl();
    return /*#__PURE__*/ React__default.createElement(Text, {
        component: "span",
        variant: "body"
    }, ' ', /*#__PURE__*/ React__default.createElement(Price, {
        value: price,
        currency: currency,
        centAmount: true
    }));
};

export { SinglePurchasePriceCaption };
//# sourceMappingURL=SinglePurchasePriceCaption.js.map
